import React from 'react';
import AOS from 'aos';
import Helmet from 'react-helmet';
import { withPrefix } from 'gatsby-link';

import './_about.scss';

class AboutPage extends React.Component {

  constructor(props) {
    super(props);

    // this.teamData = this.props.data.allAboutYaml.edges[1].node.team;
    // console.log(this.teamData);
    //this.partnersData = this.props.data.allAboutYaml.edges[1].node.partners;

  }

  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    const AOS = isBrowser ? require('aos') : undefined;
    this.aos = AOS;
    this.aos.init();
  }

  componentDidUpdate() {
    this.aos.refresh();
  }

  render() {

    let teamData = this.props.data.allAboutYaml.edges[1].node.team;
    console.log(teamData);

    return (
      <div>
        <Helmet>
          <title>About us | Invest as you spend</title>
          <meta name="description" content="We're giving Australians access to high quality financial education, technology and services." />
        </Helmet>
        <section className="first" data-aos="fade-up" data-aos-once>
          <div className="wrapper">
            <div className="inner-wrapper">
              <div className="text-center">
                <h1>Live a happier financial life</h1>
                <p>We're giving Australians access to high quality<br /> financial education, technology and services.</p>
              </div>
              <div className="feature-icons">
                <img src={withPrefix('/images/icons/icon-rising.svg')} className="feature-icon rising" alt="Feature icon" />
                <img src={withPrefix('/images/icons/icon-search.svg')} className="feature-icon search" alt="Feature icon" />
                <img src={withPrefix('/images/icons/icon-floppy.svg')} className="feature-icon floppy" alt="Feature icon" />
                <img src={withPrefix('/images/icons/icon-shield.svg')} className="feature-icon shield" alt="Feature icon" />
              </div>
            </div>
          </div>
        </section>

        <section className="team" data-aos="fade-up" data-aos-once>

          <div className="container">

            <div className="team-title">
              <p>We believe in inspiring and motivating Australians to invest. Invsting create opportunities to thrive. With FirstStep we can make it possible.</p>

              <p>Our talented team is devoted to designing and delivering powerful technology that reimagines investing and help shape a growing community realise new possibilities.</p>

              <p>To do this FirstStep places high value on trust, integrity, deep expertise, security and partnerships. Our promise is to harness great insight, hindsight and foresight and partner it with great technology enabling thousands of Australians to invest.</p>
            </div>

            <div className="members">
              <div className="row">
                {
                  teamData && teamData.map((item, index) => (
                    <div className="col-12 col-sm-4 col-lg-3" key={index}>
                      <div className="member">
                        <div className="member-photo">
                          <img src={withPrefix(item.member.image)} className="img-photo" alt="Member photo" />
                          <img src={withPrefix('/images/patterns/triangle.png')} className="bg-photo" alt="Pattern background" />
                        </div>
                        <div className="member-info">
                          <h3 class="title">{item.member.name}</h3>
                          <h5 class="caption">{item.member.title}</h5>
                        </div>
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>

          </div>
        </section>
      </div>
    );
  }
}

export default AboutPage;

export const AboutQuery = graphql`
query AboutQuery {
  allAboutYaml {
    edges {
      node {
        team {
					member {
					  name
					  title
					  image
					}
        }
      }
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/pages/about/index.js